"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Partners() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const partners = [{
    name: "REALTOR ALLIANCE",
    img: "/img/partner_realtor_alliance.webp"
  }, {
    name: "CAPITAL BROKERS",
    img: "/img/partner_capital_brokers.webp"
  }, {
    name: "CONSTRUCT GROUP",
    img: "/img/partner_construct_group.webp"
  }, {
    name: "DEVELOPER HUB",
    img: "/img/partner_developer_hub.webp"
  }, {
    name: "CREDIT REPAIR PRO",
    img: "/img/partner_credit_repair_pro.webp"
  }, {
    name: "LENDING NETWORK",
    img: "/img/partner_lending_network.webp"
  }, {
    name: "INVESTOR PLATFORM",
    img: "/img/partner_investor_platform.webp"
  }, {
    name: "ASSET MANAGEMENT",
    img: "/img/partner_asset_management.webp"
  }, {
    name: "EQUITY PARTNERS",
    img: "/img/partner_equity_partners.webp"
  }, {
    name: "FINANCE SOLUTIONS",
    img: "/img/partner_finance_solutions.webp"
  }, {
    name: "REAL ESTATE TECH",
    img: "/img/partner_real_estate_tech.webp"
  }, {
    name: "CAPITAL VENTURES",
    img: "/img/partner_capital_ventures.webp"
  }];
  const tickerItems = ["REALTOR ALLIANCE · PARTNERED SINCE 2021 · DEALS FUNDED: 140+", "CAPITAL BROKERS · PARTNERED SINCE 2020 · DEALS FUNDED: 87", "CONSTRUCT GROUP · PARTNERED SINCE 2019 · DEALS FUNDED: 212", "DEVELOPER HUB · PARTNERED SINCE 2022 · DEALS FUNDED: 56", "CREDIT REPAIR PRO · PARTNERED SINCE 2018 · DEALS FUNDED: 328", "LENDING NETWORK · PARTNERED SINCE 2020 · DEALS FUNDED: 103", "INVESTOR PLATFORM · PARTNERED SINCE 2021 · DEALS FUNDED: 174", "ASSET MANAGEMENT · PARTNERED SINCE 2022 · DEALS FUNDED: 48"];
  return <section data-section-id="5084" id="who-we-partner-with" className="bg-background text-foreground py-[120px] px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 mb-16 transition-all duration-700 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div>
            <div className="font-mono text-xs tracking-widest mb-6" style={{
            color: "var(--muted-foreground)"
          }}>
              05 / STRATEGIC ALLIANCES
            </div>
            <h3 className="font-default font-bold text-3xl md:text-4xl leading-[1.05] tracking-tight uppercase">
              The professional network<br />
              powering real estate growth.
            </h3>
          </div>
          <div className="flex lg:justify-end lg:items-end">
            <div className="flex items-center gap-3 font-mono text-xs tracking-widest">
              <span className="relative flex h-2 w-2" aria-hidden="true">
                <span className="absolute inline-flex h-full w-full animate-ping opacity-75" style={{
                backgroundColor: "var(--primary)"
              }}></span>
                <span className="relative inline-flex h-2 w-2" style={{
                backgroundColor: "var(--primary)"
              }}></span>
              </span>
              <span style={{
              color: "var(--foreground)"
            }}>
                1,200+ ACTIVE DEALS
              </span>
            </div>
          </div>
        </div>

        {}
        <div ref={gridRef} className={`border-l border-t transition-all duration-700 ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        borderColor: "var(--border)"
      }}>
          <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
            {partners.map((partner, i) => <div key={i} data-index={i} className="group relative h-[140px] md:h-[180px] flex items-center justify-center border-r border-b transition-colors duration-300" style={{
            borderColor: "var(--border)"
          }}>
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{
              backgroundColor: "var(--accent)"
            }}></div>

                {}
                <span className="pointer-events-none absolute top-2 left-2 w-3 h-3 border-t border-l opacity-0 group-hover:opacity-100 transition-all duration-300 -translate-x-1 -translate-y-1 group-hover:translate-x-0 group-hover:translate-y-0" style={{
              borderColor: "var(--primary)"
            }}></span>
                <span className="pointer-events-none absolute top-2 right-2 w-3 h-3 border-t border-r opacity-0 group-hover:opacity-100 transition-all duration-300 translate-x-1 -translate-y-1 group-hover:translate-x-0 group-hover:translate-y-0" style={{
              borderColor: "var(--primary)"
            }}></span>
                <span className="pointer-events-none absolute bottom-2 left-2 w-3 h-3 border-b border-l opacity-0 group-hover:opacity-100 transition-all duration-300 -translate-x-1 translate-y-1 group-hover:translate-x-0 group-hover:translate-y-0" style={{
              borderColor: "var(--primary)"
            }}></span>
                <span className="pointer-events-none absolute bottom-2 right-2 w-3 h-3 border-b border-r opacity-0 group-hover:opacity-100 transition-all duration-300 translate-x-1 translate-y-1 group-hover:translate-x-0 group-hover:translate-y-0" style={{
              borderColor: "var(--primary)"
            }}></span>

                <div className="relative z-10 flex items-center justify-center px-4">
                  <span className="font-default font-bold text-base md:text-lg tracking-tight transition-all duration-300 opacity-40 group-hover:opacity-100" style={{
                color: "var(--muted-foreground)"
              }}>
                    <span className="group-hover:hidden">{partner.name}</span>
                    <span className="hidden group-hover:inline" style={{
                  color: "var(--primary)"
                }}>
                      {partner.name}
                    </span>
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {}
        <div className="mt-12 border-t border-b overflow-hidden" style={{
        borderColor: "var(--border)"
      }}>
          <div className="h-10 flex items-center overflow-hidden relative">
            <div className="flex whitespace-nowrap animate-marquee">
              {[...tickerItems, ...tickerItems].map((item, i) => <div key={i} data-index={i} className="flex items-center font-mono text-xs tracking-widest px-8" style={{
              color: "var(--muted-foreground)"
            }}>
                  <span className="inline-block w-1.5 h-1.5 mr-4" style={{
                backgroundColor: "var(--primary)"
              }}></span>
                  {item}
                </div>)}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 60s linear infinite;
        }
      `}</style>
    </section>;
}